import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiGit,
} from "react-icons/di";
import { TbBrandReactNative } from "react-icons/tb";
import { SiFirebase, SiMysql } from "react-icons/si";

import {
  SiMaterialui,
  SiRedux,
  SiMongodb,
  SiHtml5
} from "react-icons/si";

const Techstack = () => {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiHtml5 style={{ color: '#ff5722' }} />
        <h6>HTML</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 style={{ color: '#f7e018' }} />
        <h6>JavaScript</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs />
        <h6>Nodejs</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact style={{ color: '#66dbfb' }} />
        <h6>Reactjs</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiRedux style={{ color: '#764abc' }} />
        <h6>Redux</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <TbBrandReactNative style={{ color: '#66dbfb' }} />
        <h6>ReactNative</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMysql style={{ color: '#55ad47' }} />
        <h6>MySQL</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMongodb style={{ color: '#55ad47' }} />
        <h6>MongoDb</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFirebase style={{ color: '#f7c427' }} />
        <h6>Firebase</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMaterialui style={{ color: '#0883ff' }} />
        <h6>MaterialUi</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit style={{ color: '#f05539' }} />
        <h6>Git & Github</h6>
      </Col>
    </Row>
  );
}

export default Techstack;
